import React, { useState } from 'react';

import { SelectField } from 'component/Form/SelectField';
import { TypeheadSelectField } from 'component/Form/TypeheadSelectField';
import { MenuItem } from 'component/MenuItem/MenuItem';
import { SurveyTypeLabel } from 'component/SurveyTypeLabel/SurveyTypeLabel';
import { CompanyModel } from 'api/dto/Company.dto';
import { ProjectModel } from 'api/dto/Project.dto';
import { Field } from 'redux-form';
import { required } from 'validator/required';
import { CircleModel } from 'api/dto/Circle.dto';

export type CreateProjectExistingCompanyProps = {
  companies: CompanyModel[];
  circles: CircleModel[];
};

export const CreateProjectExistingCompany: React.FC<CreateProjectExistingCompanyProps> = ({
  circles,
  companies,
}) => {
  const [autocompleteOptions, setAutocompleteOptions] = useState(() => {
    if (circles.length === 1) {
      return getFilteredCompaniesByCircleId(circles[0].id);
    }

    if (circles.length < 1) {
      return companies
        .map((company) => ({ id: company, name: company.name }))
        .sort((a, b) => a.name.localeCompare(b.name));
    }

    return null;
  });

  function getFilteredCompaniesByCircleId(circleId: string) {
    return companies
      .filter((company) => {
        return company.circleId === circleId;
      })
      .map((company) => ({ id: company, name: company.name }))
      .sort((a, b) => a.name.localeCompare(b.name));
  }

  return (
    <div>
      <Field
        data-testid="projectKindField"
        name="kind"
        component={SelectField}
        label="Survey type"
        validate={required('Survey type is required')}
      >
        {ProjectModel.SURVEY_TYPE.map((type, index) => (
          <MenuItem key={index} value={type}>
            <SurveyTypeLabel kind={type} />
          </MenuItem>
        ))}
      </Field>
      {circles.length > 1 && (
        <Field
          data-testid="circleField"
          name="circle"
          component={SelectField}
          label="Circle"
          validate={required('Circle is required')}
          fullWidth
          onChange={(circleId: any) => {
            setAutocompleteOptions(getFilteredCompaniesByCircleId(circleId));
          }}
        >
          {[...circles]
            .sort((a, b) => a.name.localeCompare(b.name))
            .map((circle, index) => (
              <MenuItem key={index} value={circle.id}>
                {circle.name}
              </MenuItem>
            ))}
        </Field>
      )}
      {autocompleteOptions && (
        <Field
          data-testid="companyField"
          name="company"
          component={TypeheadSelectField}
          label="Company list"
          validate={required('Company is required')}
          autocompleteOptions={autocompleteOptions}
        />
      )}
    </div>
  );
};
